import { FormControlLabel, FormHelperText, Switch } from "@mui/material";
import { FC } from "react";

import { BulkRecalculateSwitchOptionStyled } from "./bulk-recalculate-options.styled";

interface IBulkRecalculateSwitchOptionProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  helperText: string;
}

export const BulkRecalculateSwitchOption: FC<
  IBulkRecalculateSwitchOptionProps
> = ({ checked, onChange, label, helperText }) => {
  return (
    <BulkRecalculateSwitchOptionStyled>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={(_, nextChecked) => onChange(nextChecked)}
          />
        }
        label={label}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </BulkRecalculateSwitchOptionStyled>
  );
};
